import React from 'react'
import Nav from 'react-bootstrap/Nav';
import { useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';

function EmployeeNavbar() {
    const { employeeId } = useParams();

    return (
        <Nav style={{ marginLeft: "-10px" }}>
            <Nav.Link
                as={NavLink}
                to={`/employees/view/profile/${employeeId}`}
                style={({ isActive }) => ({
                    color: isActive ? 'black' : 'gray',
                    fontWeight: '500',
                })}
            >
                Profile
            </Nav.Link>
            <Nav.Link
                as={NavLink}
                to={`/employees/view/${employeeId}/project`}
                style={({ isActive }) => ({
                    color: isActive ? 'black' : 'gray',
                    fontWeight: '500',
                })}
            >
                Project
            </Nav.Link>
            <Nav.Link
                as={NavLink}
                to={`/employees/view/${employeeId}/task`}
                style={({ isActive }) => ({
                    color: isActive ? 'black' : 'gray',
                    fontWeight: '500',
                })}
            >
                Task
            </Nav.Link>
            <Nav.Link
                as={NavLink}
                to={`/employees/view/${employeeId}/timesheet`}
                style={({ isActive }) => ({
                    color: isActive ? 'black' : 'gray',
                    fontWeight: '500',
                })}
            >
                Timesheet
            </Nav.Link>
            <Nav.Link
                as={NavLink}
                to={`/employees/view/${employeeId}/document`}
                style={({ isActive }) => ({
                    color: isActive ? 'black' : 'gray',
                    fontWeight: '500',
                })}
            >
                Document
            </Nav.Link>
            <Nav.Link
                as={NavLink}
                to={`/employees/view/${employeeId}/leave`}
                style={({ isActive }) => ({
                    color: isActive ? 'black' : 'gray',
                    fontWeight: '500',
                })}
            >
                Leave
            </Nav.Link>
            <Nav.Link
                as={NavLink}
                to={`/employees/view/${employeeId}/appreciation`}
                style={({ isActive }) => ({
                    color: (isActive || location?.pathname?.includes('/award')) ? 'black' : 'gray',
                    fontWeight: '500',
                })}
            >
                Appreciation
            </Nav.Link>
            <Nav.Link
                as={NavLink}
                to={`/employees/view/${employeeId}/activity`}
                style={({ isActive }) => ({
                    color: isActive ? 'black' : 'gray',
                    fontWeight: '500',
                })}
            >
                Activity
            </Nav.Link>
        </Nav>
    );
}

export default EmployeeNavbar


